import axios from "axios";


//  export const BASE_URL = `http://192.168.1.13:9475`;
// const BASE_URL = `http://167.235.116.245:9475`;
// export const BASE_URL = `http://192.168.1.27:9475`;
export const BASE_URL = `https://beyondvr.learnablekids.com`;

// export async function loginApi(data) {
//   const response = await axios.post(`${BASE_URL}/api/v1/login`, data);
//   return response;
// }

export async function loginApi(data) {
  const response = await axios.post(`${BASE_URL}/api/v1/login-wotp`, data);
  return response;
}

export async function subscribeApi(data) {
  const response = await axios.post(`${BASE_URL}/api/v1/subscribe`, data);
  return response;
}

export async function matchOtpApi(data) {
  const response = await axios.post(`${BASE_URL}/api/v1/verify-otp`, data);
  return response;
}
export async function matchSubscribeOtpApi(data, token, deviceId) {
  const response = await axios.post(
    `${BASE_URL}/api/v1/subscription-verify`,
    data,
    {
      headers: {
        "User-Agent": navigator.userAgent
      }
    }
  );

  return response;
}

export async function getLeaderboardApi(ani) {
  const response = await axios.get(`${BASE_URL}/api/v1/leaderboard?ani=${ani}`);
  return response;
}

export async function priceApi() {
  const response = await axios.get(`${BASE_URL}/api/v1/price`);
  return response;
}

export async function unsubApi(ani) {
  const response = await axios.post(`${BASE_URL}/api/v1/auth/unsub`, ani);
  return response;
}

export async function termsApi() {
  const response = await axios.post(
    `${BASE_URL}/api/v1/auth/sendTerms`,
    {
      serviceId: "1",
      type: "terms",
    },
    
  );
  return response;
}

export async function questionsApi() {
  const response = await axios.post(
    `${BASE_URL}/api/v1/auth/sendTerms`,
    {
      serviceId: "1",
      type: "faq",
    },
   
  );
  return response;
}

export async function packInfoApi(ani) {
  const response = await axios.get(`${BASE_URL}/api/v1/auth/pack?ani=${ani}`);
  return response;
}

export async function changeCurrencyApi(data) {
  let sendResponse;
  await axios.post(`${BASE_URL}/api/v1/changeCurrency`, data).then(
    (response) => {
      //    console.log("response||| ",response);
      sendResponse = response;
    },
    (error) => {
      // console.log(error);
      sendResponse = error.response;
    }
  );
  return sendResponse;
}

export async function getCurrencyPackApi(currencyValue) {
  const response = await axios.get(
    `${BASE_URL}/api/v1/price-info?currency=${currencyValue}`
  );
  return response;
}

export async function claimRewardApi(msisdn, token, deviceId) {
  const response = await axios.post(
    `${BASE_URL}/api/v1/reward/claim/${msisdn}`,
    {},
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined,
        "X-Device-Id": deviceId,
        "User-Agent": navigator.userAgent,
      },
    }
  );
  return response;
}

